// Cart reservations are derived, not persisted: a reload or server cart update
// must not make the same units available to add for a second time.
export const getCartInventoryUsage = (cart = {}, categories = []) => {
  const products = new Map();
  (categories || []).forEach((category) => (category.products || []).forEach((product) => {
    products.set(String(product.id), product);
    (product.children || []).forEach((child) => products.set(String(child.id), child));
  }));
  const used = {};
  const reserve = (product, quantity) => {
    if (!product || !Number.isFinite(quantity) || quantity <= 0) return;
    const current = products.get(String(product.id)) || product;
    if (current.type_of_product === "composite") {
      Object.entries(current.components || {}).forEach(([id, component]) => {
        used[id] = (used[id] || 0) + quantity * Number(component.required_amount || 0);
      });
    } else if (!current.type_of_product || current.type_of_product === "stocked") {
      used[current.id] = (used[current.id] || 0) + quantity;
    }
  };
  [...(cart.cart || []), ...(cart.promo_items || [])].forEach((line) => {
    if (line.is_preordered) return;
    const quantity = Number(line.quantity);
    reserve(line, quantity);
    Object.values(line.options || {}).forEach((option) => {
      Object.values(option.selectedOptions || {}).forEach((choice) => {
        if (choice.related_product && choice.maxInventory !== null)
          reserve(choice.related_product, Number(choice.quantity) * (option.quantityExclusive ? 1 : quantity));
      });
    });
  });
  return used;
};
